import type {Components, Theme} from '@mui/material';

import {sliderClasses} from '@mui/material';

export const MuiSlider = (theme: Theme): Components['MuiSlider'] => {
  return {
    styleOverrides: {
      root: {
        height: theme.spacing(0.25),
        display: 'block',
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 0,
        padding: `${theme.spacing(1)} 0 ${theme.spacing(3.75)} 0 `,
        [`& .${sliderClasses.thumb}`]: {
          transform: 'translate(-50%, -50%)',
        },
        [`& .${sliderClasses.markLabel}`]: {
          transform: 'translate(-50%)',
        },
        
      },
      rail: {
        backgroundColor: theme.palette.line.primary,
        opacity: 1,
        top: theme.spacing(1),
      },
      thumb: {
        top: theme.spacing(1),
        width: theme.spacing(2),
        height: theme.spacing(2),
        [`&:hover, &.${sliderClasses.focusVisible}`]: {
          boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14)',
        },
      },
      mark: {
        color: theme.palette.line.tertiary,
        top: theme.spacing(1),
      },
      track: {
        top: theme.spacing(1),
        zIndex: 1,
        height: 0,
      },
      markLabel: {
        transform: 'translateX(50%)',
        color: theme.palette.text.secondary,
        top: `${theme.spacing(3.25)} !important`,
        ...theme.typography.overline,
      },
      valueLabel: {
        borderRadius: +theme.shape.borderRadius * 2,
        boxShadow: theme.elevations.level3,
        top: -theme.spacing(1),
        color: theme.palette.secondary.overlay,
        backgroundColor: theme.palette.secondary.main,
        minWidth: theme.spacing(5),
        paddingTop: theme.spacing(0.25),
        paddingBottom: theme.spacing(0.25),
        ...theme.typography.body2,
      },
    },
  };
};
